
    import '/vercel/path0/docs/demo/ant-design.md?watch=parent';
    export const toc = [];
export const frontmatter = {"title":"ant-design","toc":"menu","filename":"docs/demo/ant-design.md","lastUpdated":1767583902000,"nav":{"title":"Demo","path":"/demo"}};